import { BedTypeCode } from '../types-v2/bed-type-code';
import { CapacityColumnPrefix } from '../types-v2/columns/capacity-column-prefix.type';

export const CAPACITY_COLUMN_PREFIX: Record<BedTypeCode, CapacityColumnPrefix> =
  {
    A: 'typeA',
    B: 'typeB',
    BSecure: 'typeBSecure',
    C: 'typeC',
  };
